<template>
    <div class="container">
        <Header :isLight="isLight" :isMenuLight="isMenuLight" class="static-header"></Header>
        <div class="news-list">
            <h2 class="page-title">新闻动态</h2>
            <ul>
                <li class="news-item" v-for="(item,index) in list" :key="item.id" @click="handleToDetail(item.id)">
                    <div class="img">
                        <img :src="item.logo" alt="">
                    </div>
                    <!-- <div class="info fl"> -->
                        <h2 class="title">{{item.title}}</h2>
                        <p class="brief">{{item.subtitle}}</p>
                        <span class="time">{{$moment(item.publishTime).format('YYYY年MM月DD日')}}</span>
                    <!-- </div> -->
                </li>
            </ul>
        </div>
        <div class="pagin">
            <Page :total="totalPages" :page-size="10" size="small" @on-change="handlePageChange"></Page>
        </div>
        <Bottom></Bottom>
    </div>
</template>
<script>
import { articleListMixin } from '@/mixins/articleListMixin'

export default {
    name: 'news',
    mixins: [articleListMixin],
    data() {
        return {
            articleType: 2,
            pageNum:10
        }
    },
    created() {
        
        this.$store.commit('changeIncludes', ['news'])
    },
    beforeRouteLeave(to, from, next) {
        if (to.name.toLowerCase() !== 'articledetail') {
            this.$store.commit('changeIncludes', [])
            next()
        } else {
            next()
        }
    },
}
</script>
<style lang="less" scoped>
@import url('../assets/css/news-list.less');
</style>



// WEBPACK FOOTER //
// src/views/News.vue